
export const plans = [
    {
        name: "Básico",
        price: "2,500",
        currency: "MXN",
        description: "Para 1-3 abogados",
        features: [
            { text: "Personalización básica del perfil del despacho", included: true },
            { text: "Logo del bufete en la plataforma y documentos generados", included: true },
            { text: "Hasta 2 plantillas de documentos personalizables", included: true },
            { text: "Firmas electrónicas avanzadas con límite mensual (20/mes)", included: true },
            { text: "Almacenamiento: 5GB", included: true },
        ],
        annual: {
            price: "24,000",
            saving: "20%"
        }
    },
    {
        name: "Profesional",
        price: "5,900",
        currency: "MXN",
        description: "Para 4-10 abogados",
        features: [
            { text: "Todo lo del plan básico", included: true },
            { text: "Interfaz personalizable con colores corporativos", included: true },
            { text: "Hasta 10 plantillas de documentos personalizables", included: true },
            { text: "URL personalizada para acceso de clientes (portal.nombredespacho.com)", included: true },
            { text: "Firmas electrónicas avanzadas ampliadas (100/mes)", included: true },
            { text: "Escaneo de documentos con OCR básico", included: true },
            { text: "Reportes personalizados mensuales", included: true },
            { text: "Almacenamiento: 20GB", included: true },
        ],
        recommended: true,
        annual: {
            price: "56,640",
            saving: "20%"
        }
    },
    {
        name: "Empresarial",
        price: "12,500",
        currency: "MXN",
        description: "Para más de 10 abogados (hasta 25)",
        features: [
            { text: "Todo lo del plan profesional", included: true },
            { text: "Interfaz completamente personalizable (incluyendo distribución de elementos)", included: true },
            { text: "Plantillas de documentos ilimitadas", included: true },
            { text: "Escaneo con OCR avanzado y clasificación automática de documentos", included: true },
            { text: "Firmas electrónicas avanzadas ilimitadas", included: true },
            { text: "Flujos de trabajo personalizables según procesos específicos del despacho", included: true },
            { text: "API para integraciones con otros sistemas del bufete", included: true },
            { text: "Módulos especializados según áreas del derecho mercantil (corporativo, financiero, etc.)", included: true },
            { text: "Reportes personalizados avanzados y dashboard específico", included: true },
            { text: "Almacenamiento: 50GB", included: true },
            { text: "Por cada 5 abogados adicionales: +$2,000 MXN/mes", included: true },
        ],
        annual: {
            price: "120,000",
            saving: "20%"
        }
    },
];

// Personalizaciones adicionales (Add-ons)
export const personalizaciones = [
    { text: "Cumplimiento Regulatorio: Personalización de flujos de trabajo según normativas mexicanas específicas (CNBV, SAT, etc.)" },
    { text: "Módulo de Facturación: Integración con sistemas de facturación electrónica (CFDI)" },
    { text: "Usuarios Colaboradores: Para contadores, peritos y otros profesionales externos" },
    { text: "Integraciones con Bases de Datos Jurídicas: Conexión con bases de datos jurídicas mexicanas" },
    { text: "Certificación Avanzada: Implementación de sistemas que cumplan con los requisitos de la NOM-151 para conservación de mensajes de datos" },
];

// Complementos (Add-ons) detallados
export const addOns = [
    {
        category: "Almacenamiento adicional",
        options: [
            { name: "10GB extra", price: "500", currency: "MXN", period: "mes" },
            { name: "50GB extra", price: "2,000", currency: "MXN", period: "mes" },
            { name: "100GB extra", price: "3,500", currency: "MXN", period: "mes" },
        ]
    },
    {
        category: "Cumplimiento Regulatorio Personalizado",
        options: [
            { name: "Módulo CNBV", price: "1,200", currency: "MXN", period: "mes" },
            { name: "Módulo SAT", price: "1,200", currency: "MXN", period: "mes" },
            { name: "Paquete completo", price: "2,000", currency: "MXN", period: "mes" },
        ]
    },
    {
        category: "Facturación Electrónica",
        options: [
            { name: "Integración CFDI", price: 800, currency: "MXN", period: "mes" },
        ]
    },
    {
        category: "Usuarios Colaboradores",
        options: [
            { name: "Paquete de 5 usuarios externos", price: "1,500", currency: "MXN", period: "mes" },
        ]
    },
    {
        category: "Certificación NOM-151",
        options: [
            { name: "Implementación y mantenimiento", price: "1,800", currency: "MXN", period: "mes" },
        ]
    },
    {
        category: "Módulos Especializados",
        options: [
            { name: "Derecho Corporativo", price: "1,500", currency: "MXN", period: "mes" },
            { name: "Derecho Financiero", price: "1,500", currency: "MXN", period: "mes" },
            { name: "Propiedad Intelectual", price: "1,500", currency: "MXN", period: "mes" },
            { name: "Paquete completo", price: "3,500", currency: "MXN", period: "mes" },
        ]
    },
];